<div class="centros-container">
  <div class="global-search">
    <header>
      <div class="title-group">
        <h1>Centros de entrenamiento</h1>
        <h2>Filtros de busqueda</h2>
      </div>
    </header>
    <div>
      <label for="searchId">ID:</label>
      <input id="searchId" type="number" [(ngModel)]="searchId" (input)="filterCentros()">
    </div>
    <div>
      <label for="searchNombre">Nombre:</label>
      <input id="searchNombre" type="text" [(ngModel)]="searchNombre" (input)="filterCentros()">
    </div>
    <div>
      <label for="searchDireccion">Direccion:</label>
      <input id="searchDireccion" type="text" [(ngModel)]="searchDireccion" (input)="filterCentros()">
    </div>
    <div>
      <label for="searchIdInstructor">Instructor:</label>
      <select id="searchIdInstructor" [(ngModel)]="searchIdInstructor" (change)="filterCentros()">
        <option [ngValue]="null">-- TODOS --</option>
        <option *ngFor="let instructor of instructores" [ngValue]="instructor.id">
          {{ instructor.nombreApellido }}{{ !instructor.activo ? ' - INACTIVO' : '' }}
        </option>
      </select>
    </div>
    <div class="search-controls-row">
      <div>
        <label for="activos">Activos:</label>
        <input id="activos" type="checkbox" [(ngModel)]="activos" (change)="onActivosChange()">
      </div>
      <div>
        <label for="inactivos">Inactivos:</label>
        <input id="inactivos" type="checkbox" [(ngModel)]="inactivos" (change)="onInactivosChange()">
      </div>
      <div>
        <label for="orderBy">Ordenar por:</label>
        <select id="orderBy" [(ngModel)]="orderBy" (change)="filterCentros()">
          <option value="id">ID</option>
          <option value="nombre">Nombre</option>
          <option value="direccion">Direccion</option>
          <option value="instructor">Instructor</option>
        </select>
        <select id="orderDirection" [(ngModel)]="orderDirection" (change)="filterCentros()">
          <option value="asc">Asc</option>
          <option value="desc">Des</option>
        </select>
      </div>
    </div>
    <div class="buttons-container">
      <button (click)="clearFilters()" title="Limpiar filtros" aria-label="Clear Filters">
        <i class="fas fa-eraser"></i>
      </button>
    </div>
  </div>
  <div class="global-results">
    <header>
      <div class="title-group">
        <h1>Resultados</h1>
      </div>
      <div (click)="addCentro()" class="new-button" title="Agregar centro" aria-label="Add Centro"><i class="fas fa-plus"></i> Nuevo</div>
    </header>
    <app-popup *ngIf="showPopup" [title]="'Centro guardado'" [data]="savedData" (close)="closePopup()"></app-popup>
    <ul>
      <li *ngFor="let centro of filteredCentros" class="card">
        <div class="info">
          <div *ngIf="centro.isEditMode || !centro.disableValidation">
            <label for="">ID:</label>
            <input [(ngModel)]="centro.id" [disabled]="true" type="text">
          </div>
          <div *ngIf="centro.isEditMode || !centro.disableValidation">
            <label for="">Nombre:</label>
            <input [(ngModel)]="centro.nombre" [disabled]="!centro.isEditMode" type="text">
          </div>
          <div *ngIf="centro.isEditMode || !centro.disableValidation">
            <label for="">Direccion:</label>
            <input [(ngModel)]="centro.direccion" [disabled]="!centro.isEditMode" type="text">
          </div>
          <div *ngIf="centro.isEditMode || !centro.disableValidation">
            <label for="">Instructor:</label>
            <select [(ngModel)]="centro.idInstructor" [disabled]="!centro.isEditMode">
              <option *ngFor="let instructor of instructores" [value]="instructor.id">
                {{ instructor.nombreApellido }}{{ !instructor.activo ? ' - INACTIVO' : '' }}
              </option>
            </select>
          </div>
          <div *ngIf="centro.isEditMode || !centro.disableValidation">
            <label for="">Activo:</label>
            <input type="checkbox" [(ngModel)]="centro.activo" [disabled]="!centro.isEditMode">
          </div>
        </div>
        <div class="buttons-container">
          <button *ngIf="!centro.isEditMode" class="edit-button" (click)="toggleEditMode(centro)" title="Editar" aria-label="Edit">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button *ngIf="centro.isEditMode" (click)="guardar(centro)" [disabled]="errorMessages[centro.id]" title="Guardar" aria-label="Save">
            <i class="fas fa-save"></i>
          </button>
          <button class="cancel-btn" *ngIf="centro.isEditMode" (click)="cancelar(centro)" title="Cancelar" aria-label="Cancel">
            <i class="fas fa-times"></i>
          </button>        
        </div>
        <div *ngIf="errorMessages[centro.id]" class="error-message">{{ errorMessages[centro.id] }}</div>
      </li>
    </ul>
  </div>
</div>